import React from "react";
import { NavLink, Link } from "react-router-dom";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import { useGetAllCategoryListQuery } from "../../../utils/api/category/category.api";
import { FiPhoneCall } from "react-icons/fi";
import VersionChecker from "../../../versionChecker/VersionChecker";

const FrontFooter = () => {
  const { data } = useGetAllCategoryListQuery();
  const date = new Date();

  return (
    <footer className="footer-component">
      <div className="container pt-4 pb-3">
        <div className="row">
          {/* Colonne gauche : Marque + Contact */}
          <div className="col-lg-4 col-md-6 mb-4 footer-grid">
            <Link to="/" className="footer-brand-link">
  <h3 className="footer-brand-title">Le Coran Soigne</h3>
</Link>
            <p className="link-footer-title">Contactez-nous</p>
            <div className="footer-contact-us-container">
              <div className="footer-contact-us-item mb-3">
                <span className="footer-contact-icon-circle">
                  <AiOutlineWhatsApp style={{ fontSize: 16 }} />
                </span>
                <p className="link-footer mb-0 pb-0">
                  Whats App <br />
                  <Link
                    to="https://wa.me/message/VOSN7RAXC3CEF1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link-underline"
                  >
                    +221 77 925 45 45
                  </Link>
                </p>
              </div>
              <div className="footer-contact-us-item">
                <span className="footer-contact-icon-circle">
                  <FiPhoneCall style={{ fontSize: 16 }} />
                </span>
                <p className="link-footer pb-0 mb-0">
                  Téléphone <br />
                  <Link to="tel:+221779254545" className="footer-link-line">
                    +221 77 925 45 45
                  </Link>
                </p>
              </div>
            </div>
          </div>

          {/* Colonne centre : Nos catégories */}
          <div className="mb-4 col-lg-4 col-md-6 footer-grid">
            <p className="link-footer-title title-footer-deco pb-4">
              Nos catégories
            </p>
            <ul className="footer-list">
              {data?.results?.map((item) => (
                <li key={item?.id}>
                  <Link
                    state={{ catgoryId: item?.id }}
                    className="link-footer link-footer-deco trans-0-2"
                    to={`/produits?categorie=${item?.slug}`}
                  >
                    {item?.nom}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne droite : Liens utiles + réseaux */}
          <div className="mb-4 col-lg-4 col-md-6 footer-grid">
            <p className="link-footer-title title-footer-deco pb-4">
              Liens utiles
            </p>
            <ul className="footer-list">
              <li>
                <NavLink
                  className="link-footer link-footer-deco trans-0-2"
                  to="/a-propos-de-nous"
                >
                  Qui sommes nous ?
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="link-footer link-footer-deco trans-0-2"
                  to="/contact"
                >
                  Contactez-nous
                </NavLink>
              </li>
               <li>
                <NavLink
                  className="link-footer link-footer-deco trans-0-2"
                  to="/politique-de-confidentialite"
                >
                  Politique confidentialite
                </NavLink>
              </li>
               <li>
                <NavLink
                  className="link-footer link-footer-deco trans-0-2"
                  to="/conditions-generales-de-ventes"
                >
                  Conditions generales de vente
                </NavLink>
              </li>
            </ul>
            <div className="footer-social-icons">
              
               <a href="https://www.facebook.com/share/v/14foJCgqfU5/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Facebook Le Coran Soigne"
              >
                <FaFacebookF size={16} />
              </a>
              
              <a  href="https://www.instagram.com/le_coran_soigne?igsh=MWtoYjZ4ZjIwdnF2MQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Instagram Le Coran Soigne"
              >
                <FaInstagram size={16} />
              </a>
              
               <a href="https://www.tiktok.com/@le_coran_soigne?_r=1&_t=ZS-97Tg6ArzBHL"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="TikTok Le Coran Soigne"
              >
                <FaTiktok size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-4 pb-1 copyright-container">
          <div className="footer-separator" />
          <div className="pt-3 text-center copyright-text">
            © {date.getFullYear()}, <span className="copyright-brand">Le Coran Soigne</span>,{" "}
            <span className="copyright-sub">
              Commerce électronique propulsé par{" "}
              <Link 
                to="https://easymarket.sn"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link-underline copyright-link"
              >
                Easymarket.sn
              </Link>
            </span>
          </div>
        </div>
        <div className="version-view-container text-end text-white fw-bold">
          {"v" + VersionChecker()}
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;